// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3u0FG","label":"SetPasswdForm_label__aTzTu"};